import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getTitle, getSearchQuery } from '../selectors/seoContent'

const mapStateToProps = createStructuredSelector({
  searchQuery: getSearchQuery,
  title: getTitle,
})

export type ConnectorProps = {
  searchQuery: string
  title: string
}

export default connect(mapStateToProps)
